module.exports = __webpack_public_path__ + "img/premium-toggle.380f638f.svg";